import { useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import AuthContext from "../../../contexts/AuthContext";
import backgroundImage from "../../../assets/images/auth-bg.jpeg";
import investmentIcon from "../../../assets/icons/investment.png";
import marginLoanIcon from "../../../assets/icons/margin-loan.png";
import logo from "../../../assets/icons/csrl-logo.png";
import styles from "./LandingPage.module.css";

const Wrapper = styled("div")({
	backgroundImage: `url(${backgroundImage})`,
	backgroundSize: "cover",
	backgroundPosition: "center center",
	backgroundRepeat: "no-repeat",
	// width: "100%",
	height: "100%",
	minHeight: "100vh",
});

const Section = styled("div")({
	display: "flex",
	padding: "3vh 5vw",
	alignSelf: "center",
	alignContent: "center",
	alignItems: "center",
	height: "inherit",
	minHeight: "100%",
	justifyContent: "center",
});

const Heading = styled("div")({
	height: "auto",
	minHeight: "100px",
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-between",
	alignItems: "center",
	alignContent: "center",
	width: "fit-content",
	textAlign: "center",
	marginBottom: "1rem",
});

const BrandLogo = styled("img")({
	width: "250px",
	height: "auto",
	marginBottom: "1rem",
	maxWidth: "90%",
});

const titleStyles = {
	color: "#061e5b",
	fontWeight: "bold",
	width: "fit-content",
	textAlign: "center",
	lineHeight: "45px",
};

const AllCardWrapper = styled("div")({
	// width: "100%",
	height: "100%",
	maxWidth: "100%",
});

const CardsWrapper = styled("div")({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	alignContent: "center",
	flexWrap: "wrap",
});

const ProductCard = styled("div")({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	alignContent: "center",
	border: "1.5px solid rgb(117, 117, 158, 0.5)",
	width: "240px",
	height: "140px",
	margin: "10px",
	borderRadius: "10px",
	justifyContent: "center",
	cursor: "pointer",
	"&:hover": {
		backgroundColor: "#00256447",
	},
	"&.active": {
		backgroundColor: "#00256447 !important",
	},
});

const CardImage = styled("img")({
	height: "70px",
	marginBottom: "0.9rem",
	width: "auto",
	maxWidth: "90%",
});

const CardText = styled("p")({
	color: "#002564",
	// fontSize: "14px",
	fontWeight: 400,
	textAlign: "center",
	margin: 0,
});

const buttonContainerStyles = {
	display: "flex",
	justifyContent: "center",
	marginTop: "1rem",
};

const LandingPage = () => {
	const history = useHistory();

	const { user } = useContext(AuthContext);

	return (
		<Wrapper>
			<Section>
				{/* <div className={styles.left} /> */}
				<div className={styles.right}>
					<Heading>
						<BrandLogo src={logo} alt="CardinalStone logo" />
						<Typography
							variant="h5"
							sx={titleStyles}
							gutterBottom
							component="div"
						>
							Landing Page
						</Typography>
					</Heading>
					<AllCardWrapper>
						<CardsWrapper>
							<ProductCard
								onClick={() =>
									history.push(`/admin/kyc-update/${user.role}/dashboard`)
								}
							>
								<CardImage src={marginLoanIcon} alt="" />
								<CardText>KYC Update</CardText>
							</ProductCard>

							<ProductCard
								onClick={() => history.push("/admin/kyc-submission/dashboard")}
							>
								<CardImage src={investmentIcon} alt="" />
								<CardText>KYC Submission</CardText>
							</ProductCard>
						</CardsWrapper>
						<Box sx={buttonContainerStyles}>
							<Button component={Link} to="/logout" variant="contained">
								Logout
							</Button>
						</Box>
					</AllCardWrapper>
				</div>
			</Section>
		</Wrapper>
	);
};

export default LandingPage;
